import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '@/components/navbar';
import PublicNav from '@/components/public-nav';
import Footer from '@/components/footer';
import { AlphaBanner } from '@/components/alpha-banner';
import { useAuth } from '@/contexts/auth-context';

// List of marketing/public routes that should use the public navigation
const PUBLIC_ROUTES = [
  '/',
  '/about',
  '/about/vision',
  '/about/company', 
  '/about/values',
  '/about/blog',
  '/marketing/professionals',
  '/marketing/employers',
  '/pricing',
  '/skills-verification',
  '/privacy',
  '/terms',
  '/cookies'
];

// Helper function to check if current path matches a public route
const isPublicRoute = (pathname: string) => {
  return PUBLIC_ROUTES.some(route => {
    // Exact match
    if (route === pathname) return true;
    // Check if current path starts with route (for nested routes)
    if (route !== '/' && pathname.startsWith(route)) return true;
    return false;
  });
};

export default function Layout() {
  const location = useLocation();
  const { user } = useAuth();
  
  // Show public nav on public routes regardless of auth status
  const showPublicNav = isPublicRoute(location.pathname);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Alpha Banner - Always at the very top */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <AlphaBanner />
      </div>
      
      {/* Navigation - Positioned below banner */}
      <div className="mt-[29px]"> {/* Height of the alpha banner */}
        {showPublicNav ? <PublicNav /> : <Navbar />}
      </div>
      
      {/* Main Content */}
      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
      
      <Footer />
    </div>
  );
}